<template>

    <div class="box-tools">
        <button
            class="btn btn-box-tool"
            @click="openDocumentsConnector"
            v-tooltip="'Andere onderdelen koppelen'"
        >
            <i class="mdi mdi-plus"></i>
        </button>
        <documents-connections
            ref="documentsConnections"
            @add-connection="addConnection"
            :crm="crm"
            :projects="projects"
            :users="users"
        ></documents-connections>
    </div>

</template>

<script>

import {mapActions} from "vuex";
import axios from 'axios';
import DocumentsConnections from "./Connections";

export default {

    components:{
        DocumentsConnections,
    },

    data() {
        return {
            document:{},
            loading:true,
        }
    },

    methods: {

        ...mapActions([
            'parseData',
        ]),

        addConnection(connection) {
            axios.post(this.attachUri, connection)
                .then(() => this.$emit('connectionCompleted'))
                .catch(() => this.$emit('connectionFailed'));
        },

        openDocumentsConnector() {
            this.$refs.documentsConnections.open();
        },

    },

    mounted() {
        this.parseData();
    },

    name:'DocumentAddConnection',

    props: {
        attachUri: {
            type:String,
            required:true,
        },
        crm: {
            type:Boolean,
            default:true,
        },
        users: {
            type:Boolean,
            default:true,
        },
        projects: {
            type:Boolean,
            default:true,
        },
    }

}

</script>
